/** Streaming direction(s) a function supports (port of C# `StreamMode`). Flags. */
export enum StreamMode {
  None = 0x0,
  Push = 0x1,
  Pull = 0x2,
}
